import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
    sellerName: string;
    className?: string;
};

const OfferedBy: FC<Props> = ({ sellerName, className }) => (
    <span className={className || ''} data-tn="portfolio-row-dealer">
        <FormattedMessage
            id="dc.searchProductTile.offeredBy"
            defaultMessage={`Offered By {sellerName}`}
            values={{ sellerName }}
        />
    </span>
);

export default OfferedBy;
